import { Div, P, H2, Button, Variable, A, Progress, reactive } from 'alkali'
import './Toast.scss'
import Icon from 'components/Icon'
import * as closeIcon from 'icons/close.svg'
import * as infoIcon from 'icons/information-circle.svg'
interface ToastObject {
	id?: 'string'
	title?: Variable<string> | String
	message?: String
	// Properties for later use with timeout and action options for toasts
	action?: any
	show?: boolean
	timeout?: any
	child?: boolean
	//unless set, will show the close by default
	hover?: boolean
	// Default has arrow on the left side
	arrowDirection?: String
	learnMore?: String
	// If we want to let hover close handle hiding active toasts
	hoverClose?: Boolean
}
export const getToastPosition = (parentElement: HTMLElement | Element) => {
	const { x, y, height, width } = parentElement.getBoundingClientRect(),
	userScrolled = document.documentElement.scrollTop,
    windowWidth = window.innerWidth,
	windowHeight = window.innerHeight,
	closeToEnd = (y - 300 < 0) ? 'top' : (y + 200 > windowHeight) ? 'bottom' : false,
	closeToSide = (x - 300 < 0) ? 'left' : (x + 300 > windowWidth) ? 'right' : false,
	vwPercent = `${x * 100 / windowWidth}%`,
	vhPercent = userScrolled ? `${((y + userScrolled) * 100) / windowHeight}%` : `${y * 100 / windowHeight}%`,
	// Height of the parent element
	responsiveHeight = `${height * 100 / windowHeight}%`

	const toastCoords = {
		parentNode: parentElement,
		position: {
			responsiveHeight,
			width,
			vwPercent,
			vhPercent,
			closeToEnd,
			closeToSide
		}
	}
    return toastCoords
}
// ----------------  Scroll Remover
export const onScrollToastRemover = () => {
    const toasts = document.querySelectorAll('.toast.hover-toast')
    if(toasts){
        toasts.forEach(toast => toast.remove());
		activeToastId = null
    }
}

// ----------------   Used when hiding a toast
export const displayHiddenToast = (toastId) => {
	const toasty: HTMLElement = document.getElementById(`${toastId}`)
	// if to check if the hidden toast has been appended yet,
	// without this it will throw errors
	if (toasty === null) {
		return
	} else {
		toasty.classList.add('active')
	}
}

export const hideToast = (toastId) => {
	const toasty: HTMLElement = document.getElementById(`${toastId}`)
	if (!toasty) {
		return
	} else {
		toasty.classList.remove('active')
		activeToastId = null
		document.removeEventListener('click', toastTerminator)
	}
}

export const removeToast = (toastId) => {
	const toast = document.getElementById(toastId)
	if (toast) {
		toast!.remove()
		activeToastId = null
		document.removeEventListener('click', toastTerminator)
	} 
}

// ---------------- On Click Remover
// If toast has yet to have been added to the page the default is 0, if a toast is created then increment and decrement whenever removed
export let activeToastId = null

export const toastClickListener = () => {
	document.addEventListener('click', toastTerminator)
}

export const toastTerminator = (event) => {
	if (activeToastId) {
		// Assuming first is the only one - there can only be one
		const toast = document.querySelector('.toast')
		const el: HTMLElement = event.target
		if (toast && !toast.contains(el)) {
			toast.remove()
			activeToastId = null
			document.removeEventListener('click', toastTerminator)
		}
	} else if (activeToastId === null){
		document.removeEventListener('click', toastTerminator)
	}
}
// ----------------
export const Toast = Div.with('.toast', {
	tabIndex: -1,
	ready(properties) {
		const toasty: ToastObject = properties

		if (!toasty.child) {
			const existingToast: HTMLElement = document.getElementById(activeToastId)
			if (existingToast) {
				existingToast.remove()
			}
		}
		activeToastId = toasty?.id
		// TO DO: toasts with optional actions and timeout section
		// For toasts with actions
		// const showActions = toasty?.action.length > 0
		const showActions = false
		// For toasts with timeouts
		// const showTimeout = toasty.timeout
		const showTimeout = false

		this.append(
			new Div('.toast-split', [
				Div('.toast-left', [
					Icon('.toast-icon', {
						icon: infoIcon,
						title: toasty.title || 'Information Toast',
					}),
				]),
				Div('.toast-content', [
					Div('.toast-description', [
						toasty.title ? H2(toasty.title) : H2('Info'),
						toasty.message,
						toasty.learnMore
							? A({
									rel: 'noopenner noreferrer',
									content: 'Learn More',
									href: toasty.learnMore,
							  })
							: null,
					]),
					showActions ? Div('.toast-action', [A('OK')]) : null,
				]),
				!toasty.hover
					? Div('.toast-close', [
							Icon({
								icon: closeIcon,
								title: 'Close this toast',
								onclick: () => removeToast(toasty.id),
								tabIndex: 0,
							}),
					  ])
					: null,
			]),
			showTimeout ? new Div('.toast-progress', [Div('#toast-progress-bar')]) : null
		)
		toasty.hoverClose ? null : toastClickListener()
	}
})
